import React from 'react';

import EditListItem from 'eventbrite_design_system/editListItem/EditListItem';

import { CONFLICTS_TRANSLATIONS } from '../../constants/downgrade';

const EventsConflictsTableHeader = () => (
    <EditListItem
        data-spec="downgrade-conflicts-table-header"
        __containerClassName="eds-g-group eds-bg-color--grey-100 eds-l-pad-hor-6 eds-l-pad-vert-4"
        content={
            <span className="eds-text-bm eds-text-weight--heavy">
                {CONFLICTS_TRANSLATIONS.table.firstColumn}
            </span>
        }
        actionItems={[]}
        noWrap={true}
    >
        <div className="eds-g-cell-1-1 eds-g-cell-lg-7-12 eds-g-cell-ln-8-12 eds-g-cell-lw-7-12 eds-g-cell-md-9-12 eds-g-cell-mw-8-12 eds-g-group eds-text-color--grey-600">
            <div className="eds-g-cell eds-l-pad-hor-2 eds-text-bm eds-text-weight--heavy">
                {CONFLICTS_TRANSLATIONS.table.lastColumn}
            </div>
        </div>
    </EditListItem>
);

export default EventsConflictsTableHeader;
